export default __webpack_public_path__ + "static/media/58_desktop.3df5d707.jpg";